import { GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';


export function CustomToolbar(fileName) {
    return (
        <GridToolbarContainer>
            <GridToolbarExport
                csvOptions={{ fileName: fileName }}
            />
        </GridToolbarContainer>
    );
}

export function GetRGBFromRelativeValue(value, is_inverse=false) {
    if (is_inverse) {
        return 'rgb(' + ((parseFloat(value)) * 255) + ',' + ((1 - parseFloat(value)) * 255) + ',0)'
    }
    return 'rgb(' + ((1 - parseFloat(value)) * 255) + ',' + ((parseFloat(value)) * 255) + ',0)'
}